import { z } from 'zod';
export const brevoAudienceSyncSchema = z.object({
    audience_id: z.string().uuid(),
});
export const brevoListSyncSchema = z.object({
    list_id: z.string().uuid(),
});
export const brevoOAuthStartSchema = z.object({
    project_id: z.string().uuid(),
    integration_id: z.string().uuid().optional(),
});
//# sourceMappingURL=brevo.js.map